import ActionTypes from './ActionTypes';

const getVendorEvents = payload => {
    return{
        type: ActionTypes.GET_VENDOR_EVENTS,
        payload,
    }
}

const getPlanningTemplate = payload => {
    return{
        type: ActionTypes.GET_PLANNING_TEMPLATES,
        payload,
    }
}

const createPlanningTemplate = payload => {
    return{
        type: ActionTypes.CREATE_PLANNING_TEMPLATES,
        payload,
    }
}

const getSection = payload => {
    return{
        type: ActionTypes.GET_SECTION,
        payload,
    }
}
const getSubSection = payload => {
    return{
        type: ActionTypes.GET_SUB_SECTION,
        payload,
    }
}

const createSection = payload => {
    return{
        type: ActionTypes.CREATE_SECTION,
        payload,
    }
}
const createSubSection = payload => {
    return{
        type: ActionTypes.CREATE_SUB_SECTION,
        payload,
    }
}

const updateSection = payload => {
    return{
        type: ActionTypes.UPDATE_SECTION,
        payload,
    }
}

const deleteSection = payload => {
    return{
        type: ActionTypes.DELETE_SECTION,
        payload,
    }
}

const getQuestion = payload => {
    return{
        type: ActionTypes.GET_QUESTION,
        payload,
    }
}

const createQuestion = payload => {
    return{
        type: ActionTypes.CREATE_QUESTION,
        payload,
    }
}
const clearQuestion = () => {
    return{
        type: ActionTypes.CLEAR_QUESTION,
    }
}

const updateQuestion = payload => {
    return{
        type: ActionTypes.UPDATE_QUESTION,
        payload,
    }
}

const deleteQuestion = payload => {
    return{
        type: ActionTypes.DELETE_QUESTION,
        payload,
    }
}

const getPublicTemplate = payload => {
    return{
        type: ActionTypes.GET_PUBLIC_TEMPLATES,
        payload,
    }
}
const getViewResult = payload => {
    return{
        type: ActionTypes.GET_VIEW_RESULT,
        payload,
    }
}


export { getVendorEvents, clearQuestion, getPlanningTemplate , createPlanningTemplate, getSection, createSection, updateSection, deleteSection, getQuestion, createQuestion, updateQuestion, deleteQuestion, getPublicTemplate, getViewResult, getSubSection, createSubSection };